// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__YxcO9","info":"Panel_info__c60jW","btns":"Panel_btns__1gsmf","button":"Panel_button__a2e7S"};